import { ButtonLinkTypeEnum } from 'common/enums/ButtonLinkEnum'
import { useFiles } from 'publisher/store'
import { getFile } from 'publisher/store/file/fileSelectors'
import React from 'react'
import { CommonPublisherLinkButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-link-button-entity-or-sub-entity'
import { DownloadFileActionButtonEntityInterface } from 'src/shared/entities/button/download-file.action-button.schema'
import { DownloadFileWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/download-file-website-button.schema'

const TEST_ID = 'download-file-button'

export interface DownloadFileButtonProps {
  entity:
    | DownloadFileActionButtonEntityInterface
    | DownloadFileWebsiteActionButtonEntityInterface
}

export const DownloadFileButton = ({ entity }: DownloadFileButtonProps) => {
  const file = useFiles(files => getFile(files, entity.fileId))
  return (
    <CommonPublisherLinkButtonEntityOrSubEntity
      entity={entity}
      dataTestId={TEST_ID}
      href={file?.path || ''}
      target={ButtonLinkTypeEnum.openInNewWindow}
    />
  )
}
